module.exports = __webpack_public_path__ + "static/media/category_icon_1.05b03479.png";